import PropTypes from "prop-types";
import UserDataRow from "./UserDataRow";
import TaskTotalsRow from "./TaskTotalsRow";

const UserTaskHolder = ({ agents, isAdmin, totals, completedTotal, onTimeTotal, lateTotal }) => (
  <>
    {agents.map((s) => (
      <UserDataRow key={s.admin_user_id || s.agent_user_id} agent={s} isAdmin={isAdmin} />
    ))}

    {agents.length > 1 && (
      <TaskTotalsRow
        total={totals}
        completedTotal={completedTotal}
        onTimeTotal={onTimeTotal}
        lateTotal={lateTotal}
      />
    )}
  </>
);

UserTaskHolder.propTypes = {
  agents: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isAdmin: PropTypes.bool.isRequired,
  totals: PropTypes.number.isRequired,
  completedTotal: PropTypes.number.isRequired,
  onTimeTotal: PropTypes.number.isRequired,
  lateTotal: PropTypes.number.isRequired,
};

export default UserTaskHolder;
